"use strict";
/* tslint:disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimePeriod = exports.ResultsFindings = exports.VisitReason = exports.QualitativeResult = exports.MeasureUnit = exports.Frequency = exports.Recommendation = exports.TestType = exports.TreatmentStatus = exports.TreatmentType = exports.UsageType = exports.SubstanceType = exports.ActivitiesImpacted = exports.CancerType = exports.Cause = exports.ConditionComplications = exports.ConditionOnset = exports.ConditionStatus = exports.ConditionType = void 0;
//TODO HL-42247 - move ACORD props into a separate ACORD lib later
var ConditionType;
(function (ConditionType) {
    ConditionType["OLI_MEDCOND_AIDS"] = "OLI_MEDCOND_AIDS";
    ConditionType["OLI_MEDCOND_ARTHRI"] = "OLI_MEDCOND_ARTHRI";
    ConditionType["OLI_MEDCOND_CAD"] = "OLI_MEDCOND_CAD";
    ConditionType["OLI_MEDCOND_CANCER"] = "OLI_MEDCOND_CANCER";
    ConditionType["OLI_MEDCOND_CFS"] = "OLI_MEDCOND_CFS";
    ConditionType["OLI_MEDCOND_DIABETES"] = "OLI_MEDCOND_DIABETES";
    ConditionType["OLI_MEDCOND_DEPRESSION"] = "OLI_MEDCOND_DEPRESSION";
    ConditionType["OLI_MEDCOND_ENDOCR"] = "OLI_MEDCOND_ENDOCR";
    ConditionType["OLI_MEDCOND_FAINTING"] = "OLI_MEDCOND_FAINTING";
    ConditionType["OLI_MEDCOND_FIBROMYALGIA"] = "OLI_MEDCOND_FIBROMYALGIA";
    ConditionType["OLI_MEDCOND_HEPATITIS"] = "OLI_MEDCOND_HEPATITIS";
    ConditionType["OLI_MEDCOND_HEPC"] = "OLI_MEDCOND_HEPC";
    ConditionType["OLI_MEDCOND_HIGHBLOOD"] = "OLI_MEDCOND_HIGHBLOOD";
    ConditionType["OLI_MEDCOND_HPV"] = "OLI_MEDCOND_HPV";
    ConditionType["OLI_MEDCOND_KIDNEYSTONE"] = "OLI_MEDCOND_KIDNEYSTONE";
    ConditionType["OLI_MEDCOND_PANICATTACK"] = "OLI_MEDCOND_PANICATTACK";
    ConditionType["OLI_MEDCOND_PANCRE"] = "OLI_MEDCOND_PANCRE";
    ConditionType["OLI_MEDCOND_PREGWCOMP"] = "OLI_MEDCOND_PREGWCOMP";
    ConditionType["OLI_MEDCOND_PSYCHIATRIC"] = "OLI_MEDCOND_PSYCHIATRIC";
    ConditionType["OLI_MEDCOND_PTSD"] = "OLI_MEDCOND_PTSD";
    ConditionType["OLI_MEDCOND_PULMNODULE"] = "OLI_MEDCOND_PULMNODULE";
    ConditionType["OLI_MEDCOND_SLEEP"] = "OLI_MEDCOND_SLEEP";
    ConditionType["OLI_MEDCOND_STROKE"] = "OLI_MEDCOND_STROKE";
    ConditionType["OLI_MEDCOND_SUICIDE"] = "OLI_MEDCOND_SUICIDE";
    ConditionType["OLI_MEDCOND_THROMBOCYTOPENIA"] = "OLI_MEDCOND_THROMBOCYTOPENIA";
    ConditionType["OLI_MEDCOND_ULCER"] = "OLI_MEDCOND_ULCER";
    ConditionType["OLI_MEDCOND_D86"] = "OLI_MEDCOND_D86";
    ConditionType["OLI_MEDCOND_E34"] = "OLI_MEDCOND_E34";
    ConditionType["OLI_MEDCOND_F20"] = "OLI_MEDCOND_F20";
    ConditionType["OLI_MEDCOND_F29"] = "OLI_MEDCOND_F29";
    ConditionType["OLI_MEDCOND_F31"] = "OLI_MEDCOND_F31";
    ConditionType["OLI_MEDCOND_F42"] = "OLI_MEDCOND_F42";
    ConditionType["OLI_MEDCOND_F50"] = "OLI_MEDCOND_F50";
    ConditionType["OLI_MEDCOND_F60"] = "OLI_MEDCOND_F60";
    ConditionType["OLI_MEDCOND_F61"] = "OLI_MEDCOND_F61";
    ConditionType["OLI_MEDCOND_F68"] = "OLI_MEDCOND_F68";
    ConditionType["OLI_MEDCOND_G35"] = "OLI_MEDCOND_G35";
    ConditionType["OLI_MEDCOND_G40"] = "OLI_MEDCOND_G40";
    ConditionType["OLI_MEDCOND_G43"] = "OLI_MEDCOND_G43";
    ConditionType["OLI_MEDCOND_G45"] = "OLI_MEDCOND_G45";
    ConditionType["OLI_MEDCOND_G93"] = "OLI_MEDCOND_G93";
    ConditionType["OLI_MEDCOND_I26"] = "OLI_MEDCOND_I26";
    ConditionType["OLI_MEDCOND_I40"] = "OLI_MEDCOND_I40";
    ConditionType["OLI_MEDCOND_I48"] = "OLI_MEDCOND_I48";
    ConditionType["OLI_MEDCOND_I87"] = "OLI_MEDCOND_I87";
    ConditionType["OLI_MEDCOND_J45"] = "OLI_MEDCOND_J45";
    ConditionType["OLI_MEDCOND_J98"] = "OLI_MEDCOND_J98";
    ConditionType["OLI_MEDCOND_K50"] = "OLI_MEDCOND_K50";
    ConditionType["OLI_MEDCOND_K51"] = "OLI_MEDCOND_K51";
    ConditionType["OLI_MEDCOND_K85"] = "OLI_MEDCOND_K85";
    ConditionType["OLI_MEDCOND_L40"] = "OLI_MEDCOND_L40";
    ConditionType["OLI_MEDCOND_M45"] = "OLI_MEDCOND_M45";
    ConditionType["OLI_MEDCOND_N28"] = "OLI_MEDCOND_N28";
    ConditionType["OLI_MEDCOND_N80"] = "OLI_MEDCOND_N80";
    ConditionType["OLI_MEDCOND_N93"] = "OLI_MEDCOND_N93";
    ConditionType["OLI_MEDCOND_S09"] = "OLI_MEDCOND_S09";
    ConditionType["OLI_MEDCOND_R41"] = "OLI_MEDCOND_R41";
    ConditionType["OLI_UNKNOWN"] = "OLI_UNKNOWN";
    ConditionType["MM_MEDCOND_ABNORMALHEARTBEAT"] = "MM_MEDCOND_ABNORMALHEARTBEAT";
    ConditionType["MM_MEDCOND_ACOUSTICNEUROMA"] = "MM_MEDCOND_ACOUSTICNEUROMA";
    ConditionType["MM_MEDCOND_ADHD"] = "MM_MEDCOND_ADHD";
    ConditionType["MM_MEDCOND_ANXIETY"] = "MM_MEDCOND_ANXIETY";
    ConditionType["MM_MEDCOND_ANXIETYDEPRESSION"] = "MM_MEDCOND_ANXIETYDEPRESSION";
    ConditionType["MM_MEDCOND_BRAINTUMOR"] = "MM_MEDCOND_BRAINTUMOR";
    ConditionType["MM_MEDCOND_BREASTOVARIANCYST"] = "MM_MEDCOND_BREASTOVARIANCYST";
    ConditionType["MM_MEDCOND_CARDIOVASCULAR"] = "MM_MEDCOND_CARDIOVASCULAR";
    ConditionType["MM_MEDCOND_CARDIOVASCULAROTHER"] = "MM_MEDCOND_CARDIOVASCULAROTHER";
    ConditionType["MM_MEDCOND_CHRONICKIDNEYDISEASE"] = "MM_MEDCOND_CHRONICKIDNEYDISEASE";
    ConditionType["MM_MEDCOND_COVID"] = "MM_MEDCOND_COVID";
    ConditionType["MM_MEDCOND_COLONPOLYPS"] = "MM_MEDCOND_COLONPOLYPS";
    ConditionType["MM_MEDCOND_DIABETES1"] = "MM_MEDCOND_DIABETES1";
    ConditionType["MM_MEDCOND_DIABETES2"] = "MM_MEDCOND_DIABETES2";
    ConditionType["MM_MEDCOND_DIABETESOTHER"] = "MM_MEDCOND_DIABETESOTHER";
    ConditionType["MM_MEDCOND_DIGESTIVEOTHER"] = "MM_MEDCOND_DIGESTIVEOTHER";
    ConditionType["MM_MEDCOND_DIGESTIVEUNKNOWN"] = "MM_MEDCOND_DIGESTIVEUNKNOWN";
    ConditionType["MM_MEDCOND_DIVERTICULITIS"] = "MM_MEDCOND_DIVERTICULITIS";
    ConditionType["MM_MEDCOND_EENT"] = "MM_MEDCOND_EENT";
    ConditionType["MM_MEDCOND_EYECONDITIONPREDISPOSINGBLINDNESS"] = "MM_MEDCOND_EYECONDITIONPREDISPOSINGBLINDNESS";
    ConditionType["MM_MEDCOND_EENTOTHER"] = "MM_MEDCOND_EENTOTHER";
    ConditionType["MM_MEDCOND_ELEVATEDPSA"] = "MM_MEDCOND_ELEVATEDPSA";
    ConditionType["MM_MEDCOND_EPSTEINBARR"] = "MM_MEDCOND_EPSTEINBARR";
    ConditionType["MM_MEDCOND_GESTATIONALDIABETES"] = "MM_MEDCOND_GESTATIONALDIABETES";
    ConditionType["MM_MEDCOND_GLOMERULONEPHRITIS"] = "MM_MEDCOND_GLOMERULONEPHRITIS";
    ConditionType["MM_MEDCOND_HEMATOLOGYIMMUNOLOGY"] = "MM_MEDCOND_HEMATOLOGYIMMUNOLOGY";
    ConditionType["MM_MEDCOND_HEMATOLOGYIMMUNOLOGYOTHER"] = "MM_MEDCOND_HEMATOLOGYIMMUNOLOGYOTHER";
    ConditionType["MM_MEDCOND_HEPATITISB"] = "MM_MEDCOND_HEPATITISB";
    ConditionType["MM_MEDCOND_HEPATITISD"] = "MM_MEDCOND_HEPATITISD";
    ConditionType["MM_MEDCOND_HVSLOSS"] = "MM_MEDCOND_HVSLOSS";
    ConditionType["MM_MEDCOND_IED"] = "MM_MEDCOND_IED";
    ConditionType["MM_MEDCOND_IMMUNODEFICIENCY"] = "MM_MEDCOND_IMMUNODEFICIENCY";
    ConditionType["MM_MEDCOND_INTERSTITIALCYSTITIS"] = "MM_MEDCOND_INTERSTITIALCYSTITIS";
    ConditionType["MM_MEDCOND_KIDNEYINFECTION"] = "MM_MEDCOND_KIDNEYINFECTION";
    ConditionType["MM_MEDCOND_LYMEDISEASE"] = "MM_MEDCOND_LYMEDISEASE";
    ConditionType["MM_MEDCOND_PCOS"] = "MM_MEDCOND_PCOS";
    ConditionType["MM_MEDCOND_POLYCYSTICKIDNEY"] = "MM_MEDCOND_POLYCYSTICKIDNEY";
    ConditionType["MM_MEDCOND_PREDIABETES"] = "MM_MEDCOND_PREDIABETES";
    ConditionType["MM_MEDCOND_PROLACTINOMA"] = "MM_MEDCOND_PROLACTINOMA";
    ConditionType["MM_MEDCOND_PROSTATITIS"] = "MM_MEDCOND_PROSTATITIS";
    ConditionType["MM_MEDCOND_PSYCHIATRICOTHER"] = "MM_MEDCOND_PSYCHIATRICOTHER";
    ConditionType["MM_MEDCOND_MAJORDEPRESSION"] = "MM_MEDCOND_MAJORDEPRESSION";
    ConditionType["MM_MEDCOND_NONULCERATIVECOLITIS"] = "MM_MEDCOND_NONULCERATIVECOLITIS";
    ConditionType["MM_MEDCOND_RHEUMATICOTHER"] = "MM_MEDCOND_RHEUMATICOTHER";
    ConditionType["MM_MEDCOND_THYROIDCYSTS"] = "MM_MEDCOND_THYROIDCYSTS";
    ConditionType["MM_MEDCOND_UCOB"] = "MM_MEDCOND_UCOB";
    ConditionType["MM_MEDCOND_UCOBOTHER"] = "MM_MEDCOND_UCOBOTHER";
})(ConditionType = exports.ConditionType || (exports.ConditionType = {}));
var ConditionStatus;
(function (ConditionStatus) {
    ConditionStatus["OLI_CONDSTAT_COMPLETED"] = "OLI_CONDSTAT_COMPLETED";
    ConditionStatus["OLI_CONDSTAT_ONGOING"] = "OLI_CONDSTAT_ONGOING";
    ConditionStatus["OLI_CONDSTAT_RECOVERED"] = "OLI_CONDSTAT_RECOVERED";
    ConditionStatus["OLI_UNKNOWN"] = "OLI_UNKNNOWN";
    ConditionStatus["MM_CONDSTAT_BENIGN"] = "MM_CONDSTAT_BENIGN";
    ConditionStatus["MM_CONDSTAT_CONTROLLED"] = "MM_CONDSTAT_CONTROLLED";
    ConditionStatus["MM_CONDSTAT_CURED"] = "MM_CONDSTAT_CURED";
    ConditionStatus["MM_CONDSTAT_HEALED"] = "MM_CONDSTAT_HEALED";
    ConditionStatus["MM_CONDSTAT_MALIGNANT"] = "MM_CONDSTAT_MALIGNANT";
    ConditionStatus["MM_CONDSTAT_PAST"] = "MM_CONDSTAT_PAST";
    ConditionStatus["MM_CONDSTAT_STABLE"] = "MM_CONDSTAT_STABLE";
})(ConditionStatus = exports.ConditionStatus || (exports.ConditionStatus = {}));
var ConditionOnset;
(function (ConditionOnset) {
    ConditionOnset["ADULTHOOD"] = "ADULTHOOD";
    ConditionOnset["CHILDHOOD"] = "CHILDHOOD";
})(ConditionOnset = exports.ConditionOnset || (exports.ConditionOnset = {}));
var ConditionComplications;
(function (ConditionComplications) {
    ConditionComplications["ANY"] = "ANY";
    ConditionComplications["NONE"] = "NONE";
    ConditionComplications["BLEEDING_OBSTRUCTION"] = "BLEEDING_OBSTRUCTION";
    ConditionComplications["NEPHROPATHY"] = "NEPHROPATHY";
    ConditionComplications["RETINOPATHY"] = "RETINOPATHY";
    ConditionComplications["NEUROPATHY"] = "NEUROPATHY";
    ConditionComplications["SPEECH_DELAY_OR_DEVELOPMENTAL_ISSUE"] = "SPEECH_DELAY_OR_DEVELOPMENTAL_ISSUE";
    ConditionComplications["UNKNOWN"] = "UNKNOWN";
})(ConditionComplications = exports.ConditionComplications || (exports.ConditionComplications = {}));
var Cause;
(function (Cause) {
    Cause["OLI_CONDCAUSE_EXERCISE"] = "OLI_CONDCAUSE_EXERCISE";
    Cause["OLI_UNKNOWN"] = "OLI_UNKNOWN";
    Cause["MM_CONDCAUSE_ALCOHOL"] = "MM_CONDCAUSE_ALCOHOL";
    Cause["MM_CONDCAUSE_DIET"] = "MM_CONDCAUSE_DIET";
    Cause["MM_CONDCAUSE_SURGERY"] = "MM_CONDCAUSE_SURGERY";
})(Cause = exports.Cause || (exports.Cause = {}));
var CancerType;
(function (CancerType) {
    CancerType["BLADDER"] = "BLADDER_CANCER";
    CancerType["BREAST"] = "BREAST_CANCER";
    CancerType["BRAIN"] = "BRAIN_CANCER";
    CancerType["CERVICAL"] = "CERVICAL_CANCER";
    CancerType["COLON"] = "COLON_CANCER";
    CancerType["LEUKEMIA"] = "LEUKEMIA";
    CancerType["LYMPHOMA"] = "LYMPHOMA";
    CancerType["LUNG"] = "LUNG_CANCER";
    CancerType["OVARIAN"] = "OVARIAN_CANCER";
    CancerType["PANCREATIC"] = "PANCREATIC_CANCER";
    CancerType["PROSTATE"] = "PROSTATE_CANCER";
    CancerType["KIDNEY_RENAL"] = "KIDNEY_RENAL_CANCER";
    CancerType["SKIN_MELANOMA"] = "SKIN_CANCER_MELANOMA";
    CancerType["SKIN_OTHER"] = "SKIN_CANCER_OTHER";
    CancerType["TESTICULAR"] = "TESTICULAR_CANCER";
    CancerType["THYROID"] = "THYROID_CANCER";
    CancerType["OTHER"] = "OTHER_CANCER";
})(CancerType = exports.CancerType || (exports.CancerType = {}));
var ActivitiesImpacted;
(function (ActivitiesImpacted) {
    ActivitiesImpacted["WORK_SOCIAL"] = "WORK_SOCIAL";
    ActivitiesImpacted["DAILY_LIVING"] = "DAILY_LIVING";
    ActivitiesImpacted["NORMAL_ROUTINE"] = "NORMAL_ROUTINE";
    ActivitiesImpacted["NONE"] = "NONE";
    ActivitiesImpacted["UNKNOWN"] = "UNKNOWN";
})(ActivitiesImpacted = exports.ActivitiesImpacted || (exports.ActivitiesImpacted = {}));
var SubstanceType;
(function (SubstanceType) {
    SubstanceType["OLI_SUBSTANCE_ALCOHOL"] = "OLI_SUBSTANCE_ALCOHOL";
    SubstanceType["OLI_SUBSTANCE_CANNIBIS"] = "OLI_SUBSTANCE_CANNIBIS";
    SubstanceType["OLI_UNKNOWN"] = "OLI_UNKNOWN";
    SubstanceType["MM_SUBSTANCE_DRUGS"] = "MM_SUBSTANCE_DRUGS";
    SubstanceType["MM_SUBSTANCE_TOBACCO"] = "MM_SUBSTANCE_TOBACCO"; /** Tobacco, e-cigarettes, or other nicotine-containing products */
})(SubstanceType = exports.SubstanceType || (exports.SubstanceType = {}));
var UsageType;
(function (UsageType) {
    UsageType["HEAVY"] = "HEAVY";
    UsageType["MDOERATE"] = "MODERATE";
    UsageType["LIGHT"] = "LIGHT";
    UsageType["NONE"] = "NONE";
})(UsageType = exports.UsageType || (exports.UsageType = {}));
var TreatmentType;
(function (TreatmentType) {
    TreatmentType["OLI_TREATTYPE_CPAP"] = "OLI_TREATTYPE_CPAP";
    TreatmentType["OLI_TREATTYPE_EXCISION"] = "OLI_TREATTYPE_EXCISION";
    TreatmentType["OLI_TREATTYPE_HOSP"] = "OLI_TREATTYPE_HOSP";
    TreatmentType["OLI_TREATTYPE_MED"] = "OLI_TREATTYPE_MED";
    TreatmentType["OLI_TREATTYPE_RADIATION"] = "OLI_TREATTYPE_RADIATION";
    TreatmentType["OLI_TREATTYPE_SURGERY"] = "OLI_TREATTYPE_SURGERY";
    TreatmentType["OLI_UNKNOWN"] = "OLI_UNKNOWN";
    TreatmentType["MM_TREATTYPE_BLOODTRANSFUSION"] = "MM_TREATTYPE_BLOODTRANSFUSION";
    TreatmentType["MM_TREATTYPE_COUNSELING"] = "MM_TREATTYPE_COUNSELING";
    TreatmentType["MM_TREATTYPE_COVID"] = "MM_TREATTYPE_COVID";
    TreatmentType["MM_TREATTYPE_EMERGENCYDEPT"] = "MM_TREATTYPE_EMERGENCYDEPT";
    TreatmentType["MM_TREATTYPE_FOLLOWUP"] = "MM_TREATTYPE_FOLLOWUP";
    TreatmentType["MM_TREATTYPE_GASTRICBYPASS"] = "MM_TREATTYPE_GASTRICBYPASS";
    TreatmentType["MM_TREATTYPE_GASTROPLASTY"] = "MM_TREATTYPE_GASTROPLASTY";
    TreatmentType["MM_TREATTYPE_HEARTSURGERY"] = "MM_TREATTYPE_HEARTSURGERY";
    TreatmentType["MM_TREATTYPE_INHALER"] = "MM_TREATTYPE_INHALER";
    TreatmentType["MM_TREATTYPE_INSULIN"] = "MM_TREATTYPE_INSULIN";
    TreatmentType["MM_TREATTYPE_LAPBAND"] = "MM_TREATTYPE_LAPBAND";
    TreatmentType["MM_TREATTYPE_MASTECTOMY"] = "MM_TREATTYPE_MASTECTOMY";
    TreatmentType["MM_TREATTYPE_OTHER"] = "MM_TREATTYPE_OTHER";
    TreatmentType["MM_TREATTYPE_PACEMAKER"] = "MM_TREATTYPE_PACEMAKER";
    TreatmentType["MM_TREATTYPE_PROSTATESURGERY"] = "MM_TREATTYPE_PROSTATESURGERY";
    TreatmentType["MM_TREATTYPE_RADIOACTIVEABLATION"] = "MM_TREATTYPE_RADIOACTIVEABLATION";
    TreatmentType["MM_TREATTYPE_REMOVED"] = "MM_TREATTYPE_REMOVED";
    TreatmentType["MM_TREATTYPE_BYPASS"] = "MM_TREATTYPE_BYPASS";
    TreatmentType["MM_TREATTYPE_SPLENECTOMY"] = "MM_TREATTYPE_SPLENECTOMY";
    TreatmentType["MM_TREATTYPE_STEROIDS"] = "MM_TREATTYPE_STEROIDS";
    TreatmentType["MM_TREATTYPE_SURGERYWEIGHTLOSS"] = "MM_TREATTYPE_SURGERYWEIGHTLOSS";
    TreatmentType["MM_TREATTYPE_SPECIALIST"] = "MM_TREATTYPE_SPECIALIST";
    TreatmentType["MM_TREATTYPE_NONE"] = "MM_TREATTYPE_NONE";
})(TreatmentType = exports.TreatmentType || (exports.TreatmentType = {}));
var TreatmentStatus;
(function (TreatmentStatus) {
    TreatmentStatus["OLI_TRTMNTSTAT_COMPLETED"] = "OLI_TRTMNTSTAT_COMPLETED";
    TreatmentStatus["OLI_TRTMNTSTAT_INPROGRESS"] = "OLI_TRTMNTSTAT_INPROGRESS";
    TreatmentStatus["OLI_UNKNOWN"] = "OLI_UNKNOWN";
    TreatmentStatus["MM_TRTMNTSTAT_DOSAGECHANGE"] = "MM_TRTMNTSTAT_DOSAGECHANGE"; /** change in dosage of medication in last 2 years */
})(TreatmentStatus = exports.TreatmentStatus || (exports.TreatmentStatus = {}));
var TestType;
(function (TestType) {
    TestType["OLI_TESTTYPE_BIOPSY"] = "OLI_TESTTYPE_BIOPSY";
    TestType["OLI_TESTTYPE_COLON"] = "OLI_TESTTYPE_COLON";
    TestType["OLI_TESTTYPE_DIAGNOSTIC"] = "OLI_TESTTYPE_DIAGNOSTIC";
    TestType["OLI_TESTTYPE_EKG"] = "OLI_TESTTYPE_EKG";
    TestType["OLI_TESTTYPE_EXAM"] = "OLI_TESTTYPE_EXAM";
    TestType["OLI_TESTTYPE_LABWORK"] = "OLI_TESTTYPE_LABWORK";
    TestType["OLI_TESTTYPE_MRI"] = "OLI_TESTTYPE_MRI";
    TestType["OLI_TESTTYPE_PAP"] = "OLI_TESTTYPE_PAP";
    TestType["OLI_TESTTYPE_ULTRA"] = "OLI_TESTTYPE_ULTRA";
    TestType["OLI_TESTTYPE_XRAY"] = "OLI_TESTTYPE_XRAY";
    TestType["MM_TESTTYPE_BIOPSYCERVICAL"] = "MM_TESTTYPE_BIOPSYCERVICAL";
    TestType["MM_TESTTYPE_BIOPSYLIVER"] = "MM_TESTTYPE_BIOPSYLIVER";
    TestType["MM_TESTTYPE_BIOPSYPROSTATE"] = "MM_TESTTYPE_PROSTATE";
    TestType["MM_TESTTYPE_COVID"] = "MM_TESTTYPE_COVID";
    TestType["MM_TESTTYPE_PERIODICIMAGING"] = "MM_TESTTYPE_PERIODICIMAGING";
    TestType["MM_TESTTYPE_SURGERY"] = "MM_TESTTYPE_SURGERY";
})(TestType = exports.TestType || (exports.TestType = {}));
var Recommendation;
(function (Recommendation) {
    Recommendation["ADVISED"] = "ADVISED";
    Recommendation["PRESCRIBED"] = "PRESCRIBED";
})(Recommendation = exports.Recommendation || (exports.Recommendation = {}));
var Frequency;
(function (Frequency) {
    Frequency["OLI_USAGEFREQ_PERDAY"] = "OLI_USAGEFREQ_PERDAY";
    Frequency["OLI_USAGEFREQ_PERWEEK"] = "OLI_USAGEFREQ_PERWEEK";
    Frequency["OLI_USAGEFREQ_PERMONTH"] = "OLI_USAGEFREQ_PERMONTH";
    Frequency["OLI_USAGEFREQ_PERYEAR"] = "OLI_USAGEFREQ_PERYEAR";
    Frequency["OLI_USAGEFREQ_PERLIFETIME"] = "OLI_USAGEFREQ_PERLIFETIME";
    Frequency["OLI_USAGEFREQ_RANDOM"] = "OLI_USAGEFREQ_RANDOM";
    Frequency["OLI_USAGEFREQ_SINGLE"] = "OLI_USAGEFREQ_SINGLE";
    Frequency["OLI_UNKNOWN"] = "OLI_UNKNOWN";
    Frequency["MM_USAGEFREQ_PERNIGHT"] = "MM_USAGEFREQ_PERNIGHT";
    Frequency["MM_USAGEFREQ_MOSTNIGHTS"] = "MM_USAGEFREQ_MOSTNIGHTS";
    Frequency["MM_USAGEFREQ_EVERYWEEK"] = "MM_USAGEFREQ_EVERYWEEK";
    Frequency["MM_USAGEFREQ_THREETOFOURTIMESPERMONTH"] = "MM_USAGEFREQ_THREETOFOURTIMESPERMONTH";
    Frequency["MM_USAGEFREQ_LESSTHANTWICEPERMONTH"] = "MM_USAGEFREQ_LESSTHANTWICEPERMONTH";
})(Frequency = exports.Frequency || (exports.Frequency = {}));
var MeasureUnit;
(function (MeasureUnit) {
    MeasureUnit["OLI_MEASUNIT_HOURS"] = "OLI_MEASUNIT_HOURS";
    MeasureUnit["OLI_MEASUNITS_DAY"] = "OLI_MEASUNITS_DAY";
    MeasureUnit["OLI_MEASUNIT_WEEKS"] = "OLI_MEASUNIT_WEEK";
    MeasureUnit["OLI_MEASUNITS_YEAR"] = "OLI_MEASUNITS_YEAR";
    MeasureUnit["OLI_MEASUNIT_KG"] = "OLI_MEASUNIT_KG";
    MeasureUnit["OLI_MEASUNIT_LBS"] = "OLI_MEASUNIT_LBS";
    MeasureUnit["OLI_MEASUNIT_LIFETIME"] = "OLI_MEASUNIT_LIFETIME";
    MeasureUnit["OLI_MEASUNIT_MPERUL"] = "OLI_MEASUNIT_MPERUL";
    MeasureUnit["OLI_MEASUNIT_FRACTION"] = "OLI_MEASUNIT_FRACTION";
    MeasureUnit["OLI_UNKNOWN"] = "OLI_UNKNOWN";
    MeasureUnit["MM_MEASUNIT_WHOLE"] = "MM_MEASUNIT_WHOLE"; /** whole numbers */
})(MeasureUnit = exports.MeasureUnit || (exports.MeasureUnit = {}));
var QualitativeResult;
(function (QualitativeResult) {
    QualitativeResult["OLI_QUALVALUE_ABNORMAL"] = "OLI_QUALVALUE_ABNORMAL";
    QualitativeResult["OLI_QUALVALUE_POSITIVE"] = "OLI_QUALVALUE_POSITIVE";
    QualitativeResult["OLI_QUALVALUE_PRESENT"] = "OLI_QUALVALUE_PRESENT";
    QualitativeResult["OLI_QUALVALUE_NEGATIVE"] = "OLI_QUALVALUE_NEGATIVE";
    QualitativeResult["OLI_QUALVALUE_NORMAL"] = "OLI_QUALVALUE_NORMAL";
    QualitativeResult["OLI_UKNOWN"] = "OLI_UNKNOWN";
    QualitativeResult["MM_QUALVALUE_BENIGN"] = "MM_QUALVALUE_BENIGN";
    QualitativeResult["MM_QUALVALUE_MALIGNANT"] = "MM_QUALVALUE_MALIGNANT";
    QualitativeResult["MM_QUALVALUE_REMOVED"] = "MM_QUALVALUE_REMOVED";
})(QualitativeResult = exports.QualitativeResult || (exports.QualitativeResult = {}));
var VisitReason;
(function (VisitReason) {
    VisitReason["OLI_DRVISIT_CONSULT"] = "OLI_DRVISIT_CONSULT";
    VisitReason["OLI_DRVISIT_ROUTINE"] = "OLI_DRVISIT_ROUTINE";
    VisitReason["OLI_UNKNOWN"] = "OLI_UNKNOWN";
    VisitReason["MM_DRVISIT_NONROUTINE"] = "MM_DRVISIT_NONROUTINE";
})(VisitReason = exports.VisitReason || (exports.VisitReason = {}));
var ResultsFindings;
(function (ResultsFindings) {
    ResultsFindings["FIBROSIS"] = "FIBROSIS";
    ResultsFindings["NO_FIBROSIS"] = "NO_FIBROSIS";
    ResultsFindings["COLON_POLYPS"] = "COLON_POLYPS";
    ResultsFindings["BLOOD_PLATELETS"] = "BLOOD_PLATELETS";
})(ResultsFindings = exports.ResultsFindings || (exports.ResultsFindings = {}));
var TimePeriod;
(function (TimePeriod) {
    TimePeriod["WITHIN_ONE_YEAR"] = "WITHIN_ONE_YEAR";
    TimePeriod["ONE_TO_TWO_YEARS_AGO"] = "ONE_TO_TWO_YEARS_AGO";
    TimePeriod["TWO_TO_THREE_YEARS_AGO"] = "TWO_TO_THREE_YEARS_AGO";
    TimePeriod["MORE_THAN_THREE_YEARS_AGO"] = "MORE_THAN_THREE_YEARS_AGO";
    TimePeriod["NEVER"] = "NEVER";
    TimePeriod["PAST_MONTH"] = "PAST_MONTH";
    TimePeriod["PAST_TWO_YEARS"] = "PAST_TWO_YEARS";
    TimePeriod["PAST_THREE_YEARS"] = "PAST_THREE_YEARS";
    TimePeriod["PAST_FIVE_YEARS"] = "PAST_FIVE_YEARS";
    TimePeriod["PAST_TEN_YEARS"] = "PAST_TEN_YEARS";
    TimePeriod["GT_SIX_MONTHS"] = "GT_SIX_MONTHS"; /** greater than 6 months */
})(TimePeriod = exports.TimePeriod || (exports.TimePeriod = {}));
//# sourceMappingURL=Acord.js.map